import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

var basicAction = function basicAction(_ref) {
  var textEllipsis = _ref.textEllipsis,
      textAlignment = _ref.textAlignment,
      wordBreak = _ref.wordBreak;
  var cssModifier = [];
  if (textEllipsis) cssModifier.push('text-overflow-ellipsis');
  if (wordBreak) cssModifier.push('text-overflow-word-break');
  if (['left', 'right', 'center', 'justify'].indexOf(textAlignment) > -1) cssModifier.push("text-align-".concat(textAlignment));
  return cssModifier;
};

var instance = [basicAction];

var pipe = function pipe() {
  return {
    getInstance: function getInstance() {
      return instance;
    },
    add: function add(customModifier) {
      instance.push(customModifier);
    },
    execute: function execute(props) {
      return instance.reduce(function (temp, action) {
        return [].concat(_toConsumableArray(temp), _toConsumableArray(action(props)));
      }, []);
    }
  };
};

export default pipe;
//# sourceMappingURL=convertPropsToTextModifiers.js.map
